import PropTypes from "prop-types";
import { Radio } from "antd";
import { CreditCardOutlined, DollarOutlined, MailOutlined } from "@ant-design/icons";

const ICONS = {
    cash: DollarOutlined,
    card: CreditCardOutlined,
    send_link: MailOutlined,
};

const PaymentMethodSelector = ({ options, value, onChange, title, subtitle, compact = false }) => (
    <section
        className={
            compact ? "space-y-4" : "mt-8 space-y-4 border-t border-[#EEF0F6] pt-8"
        }>
        <div className="text-left">
            <h2 className="fontSemi text-xl text-[#222222] md:text-[22px]">{title}</h2>
            {subtitle ? (
                <p className="fontRegular mt-2 text-sm leading-6 text-[#7F8796]">{subtitle}</p>
            ) : null}
        </div>
        <div className="space-y-3">
            {options.map((option) => {
                const selected = value === option.value;
                const Icon = ICONS[option.key] || CreditCardOutlined;

                return (
                    <button
                        key={option.key}
                        type="button"
                        onClick={() => onChange(option.value)}
                        className={`w-full rounded-xl border p-4 text-left transition-colors ${
                            selected
                                ? "border-[#5D5DF6] bg-[#5D5DF6]/[0.03]"
                                : "border-[#E6EAF2] bg-white hover:border-[#5D5DF6]/40"
                        }`}>
                        <div className="flex items-start gap-3">
                            <Radio checked={selected} className="!mt-0.5 !shrink-0" />
                            <div className="flex min-w-0 flex-1 items-start gap-3">
                                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#F5F6F8] text-[#5D5DF6]">
                                    <Icon className="text-lg" />
                                </div>
                                <div className="min-w-0 flex-1">
                                    <p className="fontSemi text-base text-[#222222]">{option.title}</p>
                                    <p className="fontRegular mt-1 text-sm leading-6 text-[#7F8796]">
                                        {option.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </button>
                );
            })}
        </div>
    </section>
);

PaymentMethodSelector.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
        }),
    ).isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    compact: PropTypes.bool,
};

export default PaymentMethodSelector;
